module.exports = __webpack_public_path__ + "img/pd-img-body3.1427d633.png";